//App
export const SET_IS_LOADING = "SET_IS_LOADING";
export const SET_STAGE = "SET_STAGE";
export const SET_TRANSITION = "SET_TRANSITION";
export const SET_STORY = "SET_STORY";
export const SET_SCREEN_POPUP = "SET_SCREEN_POPUP";
